import React from 'react';
import { Hero } from '../components/Hero';
import { TrustBar } from '../components/TrustBar';
import { Services } from '../components/Services';
import { HumanImpact } from '../components/HumanImpact';
import { ImpactStats } from '../components/ImpactStats';
import { HowItWorks } from '../components/HowItWorks';
import { WhyArissa } from '../components/WhyArissa';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <>
      <Hero data-id="element-658" data-mp="24i3eq0decpkm" />
      <TrustBar data-id="element-659" data-mp="24hk8hgx3zpmf" />
      <Services data-id="element-660" data-mp="24j4rc9a29k4g" />
      <HumanImpact data-id="element-661" data-mp="29g4y6meqiqwm" />
      <ImpactStats data-id="element-662" data-mp="29flsc42czsyy" />
      <HowItWorks data-id="element-663" data-mp="29f26wddi2mg6" />
      <WhyArissa data-id="element-664" data-mp="29ek57182jg0v" />
      <Testimonials data-id="element-665" data-mp="29i80a4t5wahp" />
      <CTASection data-id="element-666" data-mp="2dhqfql27rtd5" />
    </>;
}